import { Check, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * PricingTeaserSection Component
 * 
 * Showcases the "Single Plan" strategy on the landing page
 * to provide immediate transparency before the trial CTA.
 */
function PricingTeaserSection() {
    return (
        <section className="pricing-teaser-section">
            <div className="section-container">
                <div className="section-header">
                    <div className="section-badge badge-pro">CRESTA PRO</div>
                    <h2 className="section-title">
                        Un solo plan. <span className="text-gradient bg-gradient-to-r from-emerald-400 to-teal-500">Todo incluido.</span>
                    </h2>
                    <p className="section-description">
                        Sin sorpresas, sin cobros por empleado extra y sin módulos ocultos.
                        Diseñado para escalar contigo desde el primer día.
                    </p>
                </div>

                <div className="pricing-teaser-card glass-card-strong fade-in-up">
                    <div className="pricing-teaser-header">
                        <div>
                            <h3 className="pricing-teaser-title">Suscripción Mensual</h3>
                            <p className="pricing-teaser-subtitle">Acceso ilimitado a toda la plataforma</p>
                        </div>
                        <div className="pricing-teaser-price-box">
                            <span className="pricing-teaser-currency">$</span>
                            <span className="pricing-teaser-amount">49,900</span>
                            <span className="pricing-teaser-period">COP / mes</span>
                        </div>
                    </div>

                    <div className="pricing-teaser-grid">
                        <ul className="pricing-features-list">
                            <li><Check className="text-emerald-500" size={20} /> Empleados Ilimitados</li>
                            <li><Check className="text-emerald-500" size={20} /> Agenda Inteligente y Reservas Web</li>
                            <li><Check className="text-emerald-500" size={20} /> Control Total de Inventarios</li>
                        </ul>
                        <ul className="pricing-features-list">
                            <li><Check className="text-emerald-500" size={20} /> Notificaciones WhatsApp Incluidas</li>
                            <li><Check className="text-emerald-500" size={20} /> Reportes de Rentabilidad</li>
                            <li><Check className="text-emerald-500" size={20} /> Facturación Electrónica DIAN (*)</li>
                        </ul>
                    </div>

                    <div className="pricing-teaser-footer">
                        <p className="text-sm text-gray-400">(*) La facturación electrónica requiere cuenta activa en Alegra.</p>
                        <Link to="/register" className="btn-premium pricing-cta group text-white">
                            Comienza tus 14 días gratis
                            <ArrowRight className="inline ml-2 transition-transform group-hover:translate-x-1" size={18} />
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default PricingTeaserSection;
